import { z } from 'zod';
import { IsoDateTime, UuidString } from '../../primitives.js';

/**
 * TaskWatcher — подписка юзера на события задачи. Receivable channel для
 * notifications (BE-S14-2 dispatch). Источники подписки:
 *   - explicit  — юзер вручную нажал «Подписаться»
 *   - mention   — упомянут в комментарии (auto-add)
 *   - assignee  — назначен на задачу (auto-add)
 *   - author    — создал задачу (auto-add via DB-trigger)
 *
 * См. `docs/STAITER_UX.md` §11.12 (permissions) + §11.10 (notifications);
 * `be-backlog.md` BE-S12.1-4.
 */

export const TaskWatcherSource = z.enum(['explicit', 'mention', 'assignee', 'author']);
export type TaskWatcherSource = z.infer<typeof TaskWatcherSource>;

export const TaskWatcher = z.object({
  task_id: UuidString,
  user_id: UuidString,
  source: TaskWatcherSource,
  added_at: IsoDateTime,
});
export type TaskWatcher = z.infer<typeof TaskWatcher>;
